import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentStatus } from '../utils/enum-payment-status';

@Pipe({ name: 'paymentStatus' })
export class PaymentStatusPipe implements PipeTransform {
  transform(id: number, amount?: number): string {
    if (amount !== undefined && amount < 0) {
      return `<span class="text-orange-600 font-medium">Rimborso in elaborazione</span>`;
    }
    switch (id) {
      case enumPaymentStatus.PROCESSING:
        return `<span class="text-purple-500 font-medium">In corso</span>
        `;

      case enumPaymentStatus.PAYED:
        return `<span class="text-green-500 font-medium" >Pagato</span>
        `;
      case enumPaymentStatus.NOT_PAYED:
        return `<span class="text-orange-600 font-medium">Sospeso</span>`;
    }
    return ``;
  }
}
